
import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';

import rootReducer from '../reducers';

// import { showModal } from 'actions/Modal/action';

import { saveState } from './LocalSession.js';


const devMode = process.env.NODE_ENV === 'development';


let store = '';
const history = createBrowserHistory();
const BIStoreHandler = {
  InitStore: () => {
    const persistedState = {};
    store = configureStore({
      reducer: rootReducer(history),
      preloadedState: persistedState,
      devTools: devMode,
      middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        thunk: true,
        serializableCheck: false,
        immutableCheck: false
      })
    });
    store.subscribe(() => {
      saveState('state', store.getState());
    });
    return store;
  },

  UpdateModalPopUp: (payload) => {
    // console.log('UpdateModalPopUp.payload', payload);
    if (payload.kpiContainer) {
      // store.dispatch(showModal("MODAL_TYPE_WRAPPER", payload));
    }
  }
};
window.BIStoreHandler = BIStoreHandler;
export default history;

